import { createSlice } from '@reduxjs/toolkit'
import { createSelector } from 'reselect';
import {
  setTool,
  setRanking,
  setCountryType,
  setMetric,
  setMetricOTType,
  setMetricOTValue,
  setCountry,
  setComparingCountries,
  setMetricOTChartType,
  setWorldmapYear,
} from './actions'
import { RootState } from '..'
import { IGlobalState } from '../../types'

const initialState: IGlobalState = {
  tool: 'AIVR',
  ranking: 'global',
  country: 'USA',
  countryType: 'global',
  comparingCountries: ['USA', 'CHN', 'IND', 'CAN'],
  metric: {
    rad: {
      absolute: 'number_of_total_journal_publications',
      perCapita: 'pc_number_of_total_journal_publications',
    },
    eco: {
      absolute: 'private_investment',
      perCapita: 'pc_private_investment',
    },
    edu: {
      absolute: 'number_of_ai_study_programs_in_english',
      perCapita: 'pc_number_of_ai_study_programs_in_english',
    },
    div: {
      absolute: 'ai_talent_concentration_gender_equality_index',
      perCapita: '',
    },
    pol: {
      // absolute: 'national_ai_strategy_is_released',
      // perCapita: 'pc_national_ai_strategy_is_released',
      absolute: 'num_ai_related_bills_passed',
      perCapita: 'pc_num_ai_related_bills_passed',
    },
    pub: {
      absolute: 'social_media_share_of_voice_on_ai',
      perCapita: 'pc_social_media_share_of_voice_on_ai',
    },
    inf: {
      perCapita: 'pc_parts_semiconductor_devices_export_value',
      absolute: 'parts_semiconductor_devices_export_value',
    },
    rai: {
      perCapita: 'pc_number_of_ra_submissions_aaai',
      absolute: 'number_of_ra_submissions_aaai',
    },
  },
  metricType: 'rad',
  metricValue: 'absolute',
  chartType: 'bar',
  worldmapYear: 2023,
}

export const dataAIMetricSlice = createSlice({
  name: 'AIMetricOT',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(setTool, (state, action) => {
      state.tool = action.payload.tool
    })
    builder.addCase(setRanking, (state, action) => {
      state.ranking = action.payload.ranking
    })
    builder.addCase(setCountryType, (state, action) => {
      state.countryType = action.payload.countryType
    })
    builder.addCase(setCountry, (state, action) => {
      state.country = action.payload.country
    })
    builder.addCase(setComparingCountries, (state, action) => {
      state.comparingCountries = action.payload.countries
    })
    builder.addCase(setMetric, (state, action) => {
      state.metric = action.payload.metric
    })
    builder.addCase(setMetricOTType, (state, action) => {
      state.metricType = action.payload.metricType
    })
    builder.addCase(setMetricOTValue, (state, action) => {
      state.metricValue = action.payload.metricValue
    })
    builder.addCase(setMetricOTChartType, (state, action) => {
      state.chartType = action.payload.chartType
    })
    builder.addCase(setWorldmapYear, (state, { payload }) => {
      state.worldmapYear = payload
    })
  },
})

export const inputFilter = createSelector(
  (state: RootState) => state.AIMetric,
  (AIMetric) => ({
    tool: AIMetric.tool,
    ranking: AIMetric.ranking,
    country: AIMetric.country,
    countryType: AIMetric.countryType,
    metric: AIMetric.metric,
    metricType: AIMetric.metricType,
    metricValue: AIMetric.metricValue,
    chartType: AIMetric.chartType,
    worldmapYear: AIMetric.worldmapYear,
  })
);
export const tool = (state: RootState) => state.AIMetric.tool
export const ranking = (state: RootState) => state.AIMetric.ranking
export const country = (state: RootState) => state.AIMetric.country
export const countryType = (state: RootState) => state.AIMetric.countryType
export const comparingCountries = (state: RootState) => state.AIMetric.comparingCountries
export const metric = (state: RootState) => state.AIMetric.metric
export const metricType = (state: RootState) => state.AIMetric.metricType
export const metricValue = (state: RootState) => state.AIMetric.metricValue
export const chartType = (state: RootState) => state.AIMetric.chartType
export const worldmapYear = (state: RootState) => state.AIMetric.worldmapYear

export default dataAIMetricSlice.reducer
